import React from 'react';
import { Flex, Spacer, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import FooterLink from './footerLink';

const Footer = ({ ...containerProps }) => {
  const { t } = useTranslation();

  return (
    <Flex
      color="brand.10"
      bg="secondary"
      direction={['column', 'column', 'row']}
      {...containerProps}
      alignItems="center"
      px={[0, 20]}
      py={6}
    >
      <Text color="white">{t('footerTitle')}</Text>
      <FooterLink
        href="https://chabla.zendesk.com/hc/en-us/articles/213303165-Privacy-Policy"
        text={t('dataProtection')}
        ml={[0, 0, 20]}
      />
      <FooterLink
        href="https://chabla.zendesk.com/hc/en-us/articles/212710169-Terms-of-Use"
        text={t('termsOfUse')}
        ml={[0, 0, 20]}
      />
      <Spacer />
      <FooterLink href="https://chabla.zendesk.com/hc/en-us/requests/new" text={t('feedback')} />
    </Flex>
  );
};

Footer.propTypes = {};

export default Footer;
